<template>
  <div class="profile__item-container">
    <div id="banner" class="profile__item nohover">
      <div class="profile__icon-wrapper profile__icon-wrapper--white">
        <img
          v-if="businessAccountData.accountLogo"
          :src="businessAccountData.accountLogo"
          class="profile__icon--img"
        />
        <DefaultAccountLogo v-else />
      </div>
      <div class="profile__item-responsive">
        <div class="profile__item-data-wrapper">
          <p class="profile__item-lead">
            You have INE access with your company
          </p>
          <p class="profile__item-data hide-for-small-device">
            {{ bannerSubtitle }}
          </p>
        </div>
        <ActionLoader v-if="isLoading" :size="0.5" />
        <button
          v-if="bannerButtonText && !isLoading"
          @click="buttonCta"
          :class="[
            'btn btn--secondary profile__banner-btn',
            ctaDisabled && 'profile__banner-btn--disabled',
          ]"
        >
          {{ bannerButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import DefaultAccountLogo from '@/assets/images/business/default-company-account.svg'

export default {
  name: 'BusinessLicenseBanner',
  data() {
    return {
      isLoading: false,
      ctaDisabled: false,
    }
  },
  components: {
    ActionLoader,
    DefaultAccountLogo,
  },
  props: {
    license: {
      type: Object,
      required: false,
    },
    businessAccountData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isAccOwnerOrTeamManager: 'auth/isBusinessManager',
    }),
    bannerSubtitle() {
      const accountName = this.businessAccountData.accountName
        ? this.businessAccountData.accountName
        : 'an account'
      if (this.isAccOwnerOrTeamManager) {
        return `You are a team manager on ${accountName}.`
      }
      if (this.license) {
        return `You are on ${accountName}.`
      }

      return `You are on ${accountName}. You don’t have a license.`
    },
    bannerButtonText() {
      if (this.isAccOwnerOrTeamManager) {
        return 'Go to Business platform'
      }
      if (!this.license || !this.license.active_since) {
        return 'Request a license'
      }
      return ''
    },
    businessUrl() {
      return process.env.VUE_APP_DASHBOARD_URL
    },
  },
  methods: {
    async buttonCta() {
      if (!this.license && !this.isAccOwnerOrTeamManager) {
        this.isLoading = true
        try {
          await this.$store.dispatch('business/requestLicense')
          this.$store.dispatch(
            'app/setSuccess',
            "You've successfully requested a license"
          )
          this.ctaDisabled = true
        } catch (error) {
          this.$store.dispatch('app/Error', error)
        }
        this.isLoading = false
      } else {
        window.location.assign(`//${this.businessUrl}`)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.hide-for-small-device {
  display: none;

  @include mobile {
    display: inherit;
  }
}
</style>
